import React, { useState, useEffect } from 'react';
import useDateRangeFilter from '../../../../hooks/useDateRangeFilter';
import Campaign from '../../../../templates/Campaign/Campaign';
import { Link } from 'react-router-dom';
import Loading from '../../../../templates/UI/Loading/Loading';
import moment from 'moment';
import useCallApi from '../../../../hooks/useCallApi';
import Dollars from '../../../../templates/Dollars/Dollars';
import MonitoringRatesDetail from '../MonitoringRatesDetails/MonitoringRatesDetails';

export default function MonitoringRatesComponent() {

    const { dataLoaded, data, refetch, setData } = useCallApi(`campaignHealthMonitoring/rates`, 'GET', {}, [])

    const { initStartDate, initEndDate, selectedStartDate, selectedEndDate, quickDate, handleChangeStart, handleChangeEnd, handleQuickDate } = useDateRangeFilter()

    const [modalData, setModalData] = useState({open: false, campaignId: '', ratename: '', startDate: initStartDate, endDate: initEndDate, commission: 0});

    return (        
        <div className="card mb-3 overflow-auto">
            <div className="card-header d-flex justify-content-between">
                <div className="font-weight-bold float-left">Rate Discrepancies</div>
                <Link to={`/campaigns/healthMonitoring/rates?startDate=${moment(initStartDate).format('YYYY-MM-DD')}&endDate=${moment(initEndDate).format('YYYY-MM-DD')}`}>Full Report</Link>
            </div>
            <div className="card-body p-0 table-container-scroll">
                <MonitoringRatesDetail modalData={modalData} setModalData={setModalData} />
                <table className="table table-striped table-card m-0 table-hover text-small">
                    <thead>
                        <tr className="text-secondary">
                            <th>Campaign</th>
                            <th>Ratename</th>
                            <th className="text-right border-left">Expected</th>
                            <th className="text-right">Commission</th>
                            <th className="text-right">Leads</th>
                            <th className="border-left">Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataLoaded ? (
                            (!data.report || (data.report && data.report.length === 0)) ? (
                                <tr>
                                    <td colSpan={6}>No stats available </td>
                                </tr>
                            ) : (
                                data.report.map((item, index) => {
                                    if (index > 19) return null
                                    return (
                                        <tr>
                                            <td><Campaign oid={item.offer_id} name={item.name} status={item.status}  /></td>
                                            <td><span className="badge badge-dark">{item.ratename}</span></td>
                                            <td className="text-right border-left"><Dollars value={item.expected_net_rate} /></td>
                                            <td className="text-right font-weight-bold">
                                                <a  className={item.commission_amount > item.expected_net_rate ? 'text-success' : 'text-danger'}
                                                    href="#"
                                                    onClick={(e)=>{ e.preventDefault(); setModalData({open: true, campaignId: item.offer_id, ratename: item.ratename, startDate: selectedStartDate, endDate: selectedEndDate, commission: item.commission_amount}); }}>
                                                        <Dollars value={item.commission_amount} />
                                                </a>
                                            </td>
                                            <td className="text-right">{item.lead_count}</td>
                                            <td className="border-left">{moment.utc(item.last_lead_date).format('YYYY-MM-DD HH:mm:ss')}</td>
                                        </tr>
                                    )
                                })
                            )
                        ) : (
                            <tr>
                                <td colSpan={6}>
                                    <Loading />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
    </div>
    )
}